import * as React from "react";

import MessageBox from "./MessageBox";
import { useSelector } from "react-redux";
import Logout from "./logout";

export default function NonSub() {
  const user = useSelector((state) => state.authReducer.user);

  return (
    <div className="message-box-wrapper">
      <MessageBox
        messageBoxVisible={true}
        messageTitle={`Access denied`}
        messageBody={`Please note: to use the Companyapp Outlook Add-in, you need to be a paid subscriber to the system.`}
        messageBody2={`Please contact: support@companyapp.co.uk `}
      />
      <div id="feedback-box">
        <div>
          You are logged in as: <b>{user?.current_user?.name}</b>, which is not a paid subscriber account.
        </div>
        <div>
          <Logout user={false} />
        </div>
      </div>
    </div>
  )
}